import { apiCampaignReports } from './apiCampaignReports'
import { apiCampaigns } from './apiCampaigns'
import { apiCampaignWorkflow } from './apiCampaignWorkflow'

const apiCampaignsGroup = {
	...apiCampaigns,
	...apiCampaignReports,
	...apiCampaignWorkflow,
}

export { apiCampaignsGroup }
